export default "__VITE_ASSET__CpgotLoT__"